import { types } from "../Helpers/Types";

const initialState = {
  idempleado:0,
  empleado: "",
  sucursal: "",
  departamento: "",
  puesto: "",
  adr: 0
};

export const UsuarioReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.usuario: {
      return {
        ...state,
        idempleado:action.payload.idempleado,
        empleado: action.payload.empleado,
        sucursal: action.payload.sucursal,
        departamento: action.payload.departamento,
        puesto: action.payload.puesto,
        adr: action.payload.adr
      };
    }

    default:
      return state;
  }
};
